import { useContext, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { ElaraRealtimeContext } from '../ElaraRealtimeProvider'
import { deriveElaraPageContext } from '../core/page-context'
import type { ElaraPageContext } from '../core/page-context'

export type { ElaraPageContext } from '../core/page-context'
export { deriveElaraPageContext, compactPageContext } from '../core/page-context'

/**
 * Page context from the router + the active ELARA consultation provider (which knows the
 * consultation and its patient even when the URL does not carry the patient id).
 */
export function useElaraPageContext(): ElaraPageContext {
    const location = useLocation()
    const elara = useContext(ElaraRealtimeContext)
    const consultationId = elara?.consultationContext?.consultationId || undefined
    const patientId = elara?.consultationContext?.patientId || undefined

    return useMemo(() => {
        const fromRoute = deriveElaraPageContext(location.pathname)
        return {
            ...fromRoute,
            consultationId: fromRoute.consultationId ?? consultationId,
            patientId: fromRoute.patientId ?? patientId,
        }
    }, [location.pathname, consultationId, patientId])
}
